"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyUpdateMemberV1WorkspaceMembersPostWorkspaceRole = void 0;
exports.BodyUpdateMemberV1WorkspaceMembersPostWorkspaceRole = {
    WorkspaceAdmin: "workspace_admin",
    WorkspaceMember: "workspace_member",
};
